import { isValid, isPast, isToday, parse } from "date-fns";
import {
  documentTypeMatches,
  isValidCpf as isValidCpfValue,
  isValidCnpj as isValidCnpjValue,
  isValidDocument
} from "@/utils/documents.js";

const formatEmail = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const onlyNumbersRegex = /^[0-9]/;
const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[^0-9])(?=.*[!@#$%^&*(),.?":{}|<>])./;

export const requiredInput = value =>
  !!value || value === 0 || "Este campo é obrigatório";

export const dataBankRegex = value =>
  /^[a-zA-Z0-9]*$/.test(value) || "A entrada deve ser alfanumérica sem caracteres especiais";

export const aboveZero = value =>
  value > 0 || "O valor deve ser maior do que 0.";

export const isValidCpfOrCnpj = value =>
  isValidDocument(value) || "CPF/CNPJ não é válido.";

export const dateTermValid = value => {
  if (value == null) return true;
  const [day, month, year] = value.split("/");
  return (
    (value.length == 10 && isValid(new Date(`${year}-${month}-${day}`))) ||
    "Data inválida"
  );
};

export const numberProcessValid = value =>
  (!!value && value.length == 25) || "Número do processo inválido";

export const isValidCnpjDocument = value =>
  isValidCnpjValue(value) || "CNPJ não é válido";

export const isValidCpfDocument = value =>
  isValidCpfValue(value) || "CPF não é válido";

export const isValidPhoneNumber = value =>
  !value ||
  (value || "").length === 13 ||
  (value || "").length === 14 ||
  (value || "").length === 15 ||
  "Telefone deve ser válido";

export const isValidEmail = value =>
  formatEmail.test(value) || "E-mail inválido";

export const isValidParcelPolicy = value =>
  (!!value && value <= 999 && value > 0) ||
  "Número de parcelas tem que ser maior que 1 e menor que 999";

export const isValidCep = value =>
  (value || "").length === 9 || "CEP precisa ter 8 dígitos";

export const validURL = value => {
  var pattern = new RegExp(
    "^(https?:\\/\\/)?" +
      "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" +
      "((\\d{1,3}\\.){3}\\d{1,3}))" +
      "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" +
      "(\\?[;&a-z\\d%_.~+=-]*)?" +
      "(\\#[-a-z\\d_]*)?$",
    "i"
  );
  const isUrl = value ? Boolean(pattern.test(value)) : true;
  return isUrl || "Site inválido";
};

export const passwordRules = value =>
  (value.length > 7 && passwordRegex.test(value)) ||
  "Senha deve ter pelo menos 8 caracteres contendo pelo menos um caracter maiúsculo, minúsculo, especial e número";

export const maxLengthTextArea = value =>
  !value ||
  (!!value && value.length <= 512) ||
  "Campo deve ter no máximo 512 caracteres";

export const minLengthTextArea = value =>
  !value ||
  (!!value && value.length > 3) ||
  "Campo deve ter acima de 3 caracteres";

export const maxLengthNumber = value =>
  (!!value && value.length <= 10) || "Campo deve ter no máximo 10 caracteres";

export const maxLengthPhysicalProcess = value =>
  (!!value && value.length <= 30) || "Campo deve ter no máximo 30 caracteres";

export const documentNumberMatchesType = (type, document) =>
  documentTypeMatches(
    type == "pessoa_fisica" ? "cpf" : "cnpj",
    document?.numero_documento || document
  ) || "Tipo e documentação devem ser do mesmo tipo";

export const greaterThanZero = value =>
  value > 0 || "Valor deve ser superior a 0";

export const validSusep = value =>
  (value.length >= 5 && value.length <= 9 && onlyNumbersRegex.test(value)) ||
  "SUSEP inválido";

export const isTodayOrGreater = value => {
  const date = parse(value, "dd/MM/yyyy", new Date());
  return (
    isToday(date) || !isPast(date) || "Data deve ser igual ou superior a hoje"
  );
};
